/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const deleteCandidatesByEmailDataSchema = z.object({
	email: z.string().email(),
	organisationId: z.string().uuid(),
})

export type DeleteCandidatesByEmailDataSchema = z.infer<typeof deleteCandidatesByEmailDataSchema>
